// GENERATED FILE - DO NOT MODIFY

export enum GetHappeningsSortColumnDto {
    Name = "Name",
    StartTime = "StartTime",
    OfficeName = "OfficeName",
    AttendanceType = "AttendanceType",
    NumberOfAttendees = "NumberOfAttendees",
}